import { useTranslation } from "react-i18next";

import { DashboardSummary } from "@components/organisms/dashboardSummary";
import { useGetAdminProfileStatistics } from "@api/system";

export function SuperAdminDashboard() {
  const { t } = useTranslation("field");

  const { data, isFetching, isError } = useGetAdminProfileStatistics();

  return (
    <DashboardSummary
      items={[
        {
          key: "facultyCount",
          name: t("facultyCount"),
          value: data?.data?.total_faculties || 0,
        },
        {
          key: "academicFieldCount",
          name: t("academicFieldCount"),
          value: data?.data?.total_academic_groups || 0,
        },
        {
          key: "usersCount",
          name: t("usersCount"),
          value: data?.data?.total_users || 0,
        },
        {
          key: "localAdminsCount",
          name: t("localAdminsCount"),
          value: data?.data?.total_admins || 0,
        },
        {
          key: "staffsCount",
          name: t("staffsCount"),
          value: data?.data?.total_staffs || 0,
        },
        {
          key: "facultyMemberCount",
          name: t("facultyMemberCount"),
          value: data?.data?.total_faculty_members || 0,
        },
      ]}
      isLoading={isFetching}
      isError={isError}
    />
  );
}
